import { render, staticRenderFns } from "./CadastroTerritorio.vue?vue&type=template&id=4f8ee3f8&scoped=true&lang=pug"
import script from "./CadastroTerritorio.vue?vue&type=script&lang=js"
export * from "./CadastroTerritorio.vue?vue&type=script&lang=js"
import style0 from "./CadastroTerritorio.vue?vue&type=style&index=0&id=4f8ee3f8&prod&lang=scss&scoped=true"
import style1 from "./CadastroTerritorio.vue?vue&type=style&index=1&id=4f8ee3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ee3f8",
  null
  
)

export default component.exports